import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getUseFullViewport } from '../store/selectors/useFullViewportSelector';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';
import { routes as TeamSummaryMatchupRoutes } from '../../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import { routes as MediaLinkRoutesRoutes } from '../../MediaLinks/MediaLinksDataContainer';
import { routes as BroadcasterRoutes } from '../../Broadcasters/containers/BroadcastersDataContainer';
import { routes as PitchFXRoutes } from '../../PitchFx/PitchFxDataContainer';
import LiveMiniHome from '../LiveMiniHome';

const routes = [{
    path: '/:teams?/:year?/:month?/:day?/:gamepk/live/:tab?/:detail?',
    exact: false,
    routes: [
        ...PitchFXRoutes,
        ...TeamSummaryMatchupRoutes,
        ...MediaLinkRoutesRoutes,
        ...BroadcasterRoutes
    ]
}];

const LiveMiniHomeDataContainer = ({ game_view }) => {
    const useFullViewport = useSelector(getUseFullViewport);
    return (
        <ErrorBoundaryWrapper componentName='LiveMiniHomeDataContainer'>
            <LiveMiniHome strikezoneOnly={game_view === 'strikezone'} gameContextOnly={game_view === 'gamecontext'} useFullViewport={useFullViewport} />
        </ErrorBoundaryWrapper>
    );
};

LiveMiniHomeDataContainer.propTypes = {
    game_view: PropTypes.string
};
export default LiveMiniHomeDataContainer;
export { routes };
